import { DefaultTeamLogo, type ImageDTO } from '@capsicum/common';

export const findTeamLogo = (postArrayImages: Array<ImageDTO>, imageType: string) => {
	return postArrayImages.find((image: ImageDTO) => image?.imageType?.type === imageType)?.url ?? DefaultTeamLogo;
};

export const getExtendedImagesData = (images: Array<ImageDTO>) =>
	images?.map(image => {
		return {
			...image,
			thumbnailUrl: image.url
		};
	});

export const getImagesWithTransformedDimensions = (images: Array<ImageDTO & { h?: string; w?: string }>) =>
	images?.map(image => {
		return {
			...image,
			height: image.height || image?.h,
			width: image.width || image?.w
		};
	});

export const getThumbnailUrlAwareImages = (images: Array<ImageDTO & { thumbnailUrl?: string; url?: string }>) =>
	images?.map(image => {
		return {
			...image,
			thumbnailUrl: image.thumbnailUrl || image.url
		};
	});

export const sortByCreatedAt = (images: Array<ImageDTO & { createdAt: string }>) => {
	/** If images can't be sorted by createdAt just return them with the same order */
	if (!images[0]?.createdAt) return images;

	return [...images].sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1));
};
